<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/elements-content -->
<div
  class="app-shell"
  [class.app-shell--mobile-nav-open]="mobileNavOpen()"
  [class.app-shell--panel]="isPanelRoute()"
>
  <header class="app-shell__header">
    <a class="app-shell__logo" routerLink="/dashboard" aria-label="باکارت">
      <ntt-svg name="bacart-logo-h" />
    </a>

    <nav class="app-shell__nav">
      @for (link of navLinks; track link.path) {
        @if (link.openInNewTab) {
          <a
            nttNavItem
            [href]="link.path"
            target="_blank"
            rel="noopener noreferrer"
          >
            @if (link.icon) {
              <i nttNavItemIcon [class]="'icon-' + link.icon"></i>
            }
            {{ link.label }}
          </a>
        } @else {
          <a
            nttNavItem
            routerLinkActive="ntt-nav-item--current"
            [routerLink]="link.path"
          >
            @if (link.icon) {
              <i nttNavItemIcon [class]="'icon-' + link.icon"></i>
            }
            {{ link.label }}
          </a>
        }
      }
    </nav>

    <div class="app-shell__actions">
      <div class="app-shell__cart">
        <button
          nttButton
          size="sm"
          theme="outline"
          id="cart-trigger"
          [nttDropdownMenuTrigger]="cartMenu"
        >
          سبد خرید
          <i class="icon-shopping-cart-03"></i>
        </button>
        @if (cartStore.itemCount() > 0) {
          <ntt-badge
            class="app-shell__cart-count"
            color="success"
            size="sm"
            radius="circle"
            >{{ cartStore.itemCount() }}</ntt-badge
          >
        }
        <ntt-dropdown-menu
          #cartMenu
          anchor="cart-trigger"
          [disabled]="isBasketRoute()"
        >
          <ntt-dropdown-menu-items>
            <bcm-cart-dropdown-content
              [items]="cartStore.items()"
              [totalPayableAmount]="cartStore.totalPayable()"
              [currencyName]="cartStore.rialCurrencyName()"
            />
          </ntt-dropdown-menu-items>
        </ntt-dropdown-menu>
      </div>
      @if (themeToggleEnabled) {
        <button
          nttNavButton
          size="md"
          [attr.aria-label]="
            themeService.isDark() ? 'تغییر به حالت روشن' : 'تغییر به حالت تاریک'
          "
          (click)="toggleTheme()"
        >
          <i [class]="themeService.isDark() ? 'icon-sun' : 'icon-moon-01'"></i>
        </button>
      }
      <div class="app-shell__account">
        <button
          class="app-shell__account-trigger"
          id="account-trigger"
          aria-label="حساب کاربری"
          [nttDropdownMenuTrigger]="accountMenu"
        >
          <ntt-avatar size="md" [placeholder]="true" />
        </button>
        <ntt-dropdown-menu #accountMenu anchor="account-trigger">
          <ntt-dropdown-menu-items>
            @for (link of accountLinks; track link.path) {
              <ntt-dropdown-menu-item
                [label]="link.label"
                [icon]="link.icon ?? null"
                (itemClick)="navigateTo(link.path)"
              />
            }
            <ntt-dropdown-menu-divider />
            <ntt-dropdown-menu-item
              label="خروج از حساب کاربری"
              icon="log-out-01"
              [loading]="logoutLoading()"
              [closeOnClick]="false"
              (itemClick)="handleLogout()"
            />
          </ntt-dropdown-menu-items>
        </ntt-dropdown-menu>
      </div>
      <button
        nttNavHamburger
        class="app-shell__hamburger"
        [opened]="mobileNavOpen()"
        (openedChange)="handleHamburgerClick()"
      ></button>
    </div>
  </header>

  @if (mobileNavOpen()) {
    <div class="app-shell__overlay" (click)="closeMobileNav()">
      <div class="app-shell__mobile-wrapper" (click)="$event.stopPropagation()">
        <header class="app-shell__mobile-header">
          <button
            class="app-shell__close-button"
            aria-label="بستن"
            (click)="closeMobileNav()"
          >
            <i class="icon-x-close"></i>
          </button>
          <a
            class="app-shell__mobile-logo"
            routerLink="/dashboard"
            aria-label="باکارت"
            (click)="closeMobileNav()"
          >
            <ntt-svg name="bacart-logo-h" />
          </a>
          <div class="app-shell__mobile-spacer"></div>
        </header>

        <nav class="app-shell__mobile-nav">
          @for (section of mobileNavSections; track $index) {
            @if (section.label) {
              <span class="app-shell__mobile-nav-heading text-xs-semi-bold">
                {{ section.label }}
              </span>
            }
            @for (link of section.links; track link.path) {
              @if (link.openInNewTab) {
                <a
                  nttNavItem
                  [href]="link.path"
                  target="_blank"
                  rel="noopener noreferrer"
                  (click)="closeMobileNav()"
                >
                  @if (link.icon) {
                    <i nttNavItemIcon [class]="'icon-' + link.icon"></i>
                  }
                  {{ link.label }}
                </a>
              } @else {
                <a
                  nttNavItem
                  routerLinkActive="ntt-nav-item--current"
                  [routerLink]="link.path"
                  (click)="closeMobileNav()"
                >
                  @if (link.icon) {
                    <i nttNavItemIcon [class]="'icon-' + link.icon"></i>
                  }
                  {{ link.label }}
                </a>
              }
            }
          }
          <button
            nttNavItem
            class="app-shell__logout-item"
            [disabled]="logoutLoading()"
            (click)="handleLogout()"
          >
            @if (logoutLoading()) {
              <ntt-spinner nttNavItemIcon size="sm" />
            } @else {
              <i nttNavItemIcon class="icon-log-out-01"></i>
            }
            خروج از حساب کاربری
          </button>
        </nav>
      </div>
    </div>
  }

  <main class="app-shell__content-wrapper">
    <div class="app-shell__content">
      <router-outlet />
    </div>
  </main>

  <bcm-bottom-nav class="app-shell__bottom-nav" />
</div>
